// Paths
import { Routes } from '@angular/router';
import { MemberModulePaths } from 'src/app/constants/routes';

// Guards
import { MemberSessionGuard } from 'src/app/guards/member-session.guard';

// Components
import { MemberDashboardComponent } from 'src/app/components/member/dashboard.component';

import { MemberAvailableBenefitsComponent } from 'src/app/components/member/benefits/available-benefits.component';
import { MemberMyBenefitsComponent } from 'src/app/components/member/benefits/my-benefits.component';
import { EnrollmentOnboardingComponent } from 'src/app/components/member/benefit-enrollment/onboarding-wizard.component';
import { EnrollmentBenefitManagerComponent } from 'src/app/components/member/benefit-enrollment/enrollment-manager.component';

import { ProfileMemberComponent } from 'src/app/components/member/profile/member.component';
import { ProfileDependentsComponent } from 'src/app/components/member/profile/dependents.component';

import { MemberDocumentBenefitsComponent } from 'src/app/components/member/documents/benefit.component';
import { MemberDocumentContactsComponent } from 'src/app/components/member/documents/contacts.component';
import { MemberDocumentCompanyComponent } from 'src/app/components/member/documents/company.component';
import { MemberDocumentComplianceComponent } from 'src/app/components/member/documents/compliance.component';
import { MemberDocumentBenefitSummariesComponent } from 'src/app/components/member/documents/benefit-summaries.component';
import { MemberDocumentForm1095sComponent } from 'src/app/components/member/documents/form-1095s.component';
import { MemberDocumentW2FormsComponent } from 'src/app/components/member/documents/w2-forms.component';

import { BenefitChangeRequestComponent } from 'src/app/components/member/benefits/benefit-change-request.component';
import { QLEComponent } from 'src/app/components/member/benefits/qle.component';
import { DependentVerificationComponent } from 'src/app/components/member/benefits/dependent-verification.component';
import { PaymentInformationComponent } from 'src/app/components/shared/payment-information.component';
// import { MemberRelationsFollowUpCompletedComponent } from 'src/app/components/member/relations/follow-up-completed.component';
// import { MemberRelationsFollowUpOpenComponent } from 'src/app/components/member/relations/follow-up-open.component';
// import { MemberActivityLogComponent } from 'src/app/components/member/relations/activity-log.component';
import { AccountTransactionsComponent } from 'src/app/components/member/accounting/account-transactions.component';

import { PayrollAddressComponent } from 'src/app/components/member/payroll/address/address.component';
import { PayrollAddressFormComponent } from 'src/app/components/member/payroll/address/address-form.component';
import { PayrollDeductionsComponent } from 'src/app/components/member/payroll/deductions.component';
import { PayrollFederalTaxTableComponent } from 'src/app/components/member/payroll/federal-tax/federal-tax.component';
import { PayrollFederalTaxFormComponent } from 'src/app/components/member/payroll/federal-tax/federal-tax-form.component';
import { PayrollPTOSickHoursComponent } from 'src/app/components/member/payroll/pto-sick-hours.component';
import { PayrollAnnualStatementsComponent } from 'src/app/components/member/payroll/annual-statements.component';
import { PayrollPayStubsComponent } from 'src/app/components/member/payroll/pay-stub/paystubs.component';
import { PayrollStateTaxTableComponent } from 'src/app/components/member/payroll/state-tax/state-tax.component';
import { PayrollStateTaxFormComponent } from 'src/app/components/member/payroll/state-tax/state-tax-form.component';
import { PayrollDirectDepositComponent } from 'src/app/components/member/payroll/direct-deposit/direct-deposit.component';
import { PayrollDirectDepositFormComponent } from 'src/app/components/member/payroll/direct-deposit/direct-deposit-form.component';
import { PayrollDashboardComponent } from 'src/app/components/member/payroll/dashboard/payroll-dashboard.component';
import { PaycheckDetailsComponent } from 'src/app/components/member/payroll/dashboard/paycheck-details.component';
import { CurrentDeductionsComponent } from 'src/app/components/member/payroll/dashboard/current-deductions.component';


import { BenefitEnrollmentGuard } from 'src/app/guards/benefit-enrollment.guard';
import { USAePayGuard } from 'src/app/guards/usaepay.guard';
import { AccountGuard } from 'src/app/guards/account.guard';
import { ACAGuard } from 'src/app/guards/aca.guard';
import { QLEGuard } from 'src/app/guards/qle.guard';
import { BeneficiariesComponent } from 'src/app/components/member/benefits/components/beneficiaries/beneficiaries.component';
import { BeneficiariesBenefitSelectComponent } from 'src/app/components/member/benefits/components/beneficiaries/beneficiaries-benefit-select.component';
import { PayrollGuard } from 'src/app/guards/payroll.guard';

const MemberDashboardComponents = [
    MemberDashboardComponent
];

// Exports
export const Member1DashboardRoutes: Routes = [
    {
        path: MemberModulePaths.Dashboard,
        component: MemberDashboardComponent,
        canActivate: [MemberSessionGuard]
    },
];

const MemberBenefitComponents = [
    MemberAvailableBenefitsComponent,
    MemberMyBenefitsComponent,
    EnrollmentOnboardingComponent,
    EnrollmentBenefitManagerComponent,
    BenefitChangeRequestComponent,
    QLEComponent,
    BeneficiariesComponent,
    BeneficiariesBenefitSelectComponent,
    DependentVerificationComponent,
    PaymentInformationComponent,
];

export const Member2BenefitRoutes: Routes = [
    {
        path: MemberModulePaths.Benefits,
        redirectTo: MemberModulePaths.BenefitsAvailable,
        pathMatch: 'full',
    },
    {
        path: MemberModulePaths.BenefitsAvailable,
        component: MemberAvailableBenefitsComponent,
        canActivate: [MemberSessionGuard]
    },
    {
        path: MemberModulePaths.BenefitsMyBenefits,
        component: MemberMyBenefitsComponent,
        canActivate: [MemberSessionGuard]
    },
    {
        path: MemberModulePaths.BenefitsDashboard,
        component: EnrollmentOnboardingComponent,
        canActivate: [MemberSessionGuard]
    },
    {
        path: MemberModulePaths.BenefitsChangeRequests,
        component: BenefitChangeRequestComponent,
        canActivate: [MemberSessionGuard]
    },
    {
        path: MemberModulePaths.BenefitsLifeEventRequests,
        component: QLEComponent,
        canActivate: [MemberSessionGuard, QLEGuard]
    },
    {
        path: MemberModulePaths.BenefitsBeneficiaries,
        component: BeneficiariesComponent,
        canActivate: [MemberSessionGuard]
    },
    {
        path: MemberModulePaths.BenefitsDependentVerification,
        component: DependentVerificationComponent,
        canActivate: [MemberSessionGuard]
    },

    {
        path: MemberModulePaths.BenefitEnrollment,
        component: EnrollmentBenefitManagerComponent,
        canActivate: [MemberSessionGuard, BenefitEnrollmentGuard]
    },
    {
        path: MemberModulePaths.PaymentInformation,
        component: PaymentInformationComponent,
        canActivate: [MemberSessionGuard, USAePayGuard]
    }
];

const MemberProfileComponents = [
    ProfileMemberComponent,
    ProfileDependentsComponent,
];

export const Member3ProfileRoutes: Routes = [
    {
        path: MemberModulePaths.Profile,
        redirectTo: MemberModulePaths.ProfileMember,
        pathMatch: 'full',
    },
    {
        path: MemberModulePaths.ProfileMember,
        component: ProfileMemberComponent,
        canActivate: [MemberSessionGuard]
    },
    {
        path: MemberModulePaths.ProfileDependents,
        component: ProfileDependentsComponent,
        canActivate: [MemberSessionGuard]
    },
    {
        path: MemberModulePaths.ProfileBeneficiaries,
        component: BeneficiariesComponent,
        canActivate: [MemberSessionGuard]
    },
];

const MemberAccountingComponents = [
    AccountTransactionsComponent,
    PaymentInformationComponent,
];

export const Member4AccountingRoutes: Routes = [
    {
        path: MemberModulePaths.Accounting,
        redirectTo: MemberModulePaths.AccountingTransactions,
        pathMatch: 'full',
    },
    {
        path: MemberModulePaths.AccountingTransactions,
        component: AccountTransactionsComponent,
        canActivate: [MemberSessionGuard, AccountGuard]
    },
    {
        path: MemberModulePaths.AccountingPaymentInformation,
        component: PaymentInformationComponent,
        canActivate: [MemberSessionGuard, AccountGuard, USAePayGuard]
    },
];

const MemberResourceComponents = [
    MemberDocumentBenefitsComponent,
    MemberDocumentContactsComponent,
    MemberDocumentCompanyComponent,
    MemberDocumentComplianceComponent,
    MemberDocumentBenefitSummariesComponent,
    MemberDocumentForm1095sComponent,
    MemberDocumentW2FormsComponent,
];

export const Member5DocumentsRoutes: Routes = [
    {
        path: MemberModulePaths.Documents,
        redirectTo: MemberModulePaths.DocumentsBenefitsSummaries,
        pathMatch: 'full',
    },
    {
        path: MemberModulePaths.DocumentsW2,
        component: MemberDocumentW2FormsComponent,
        canActivate: [MemberSessionGuard, PayrollGuard]
    },
    {
        path: MemberModulePaths.DocumentsForm1095,
        component: MemberDocumentForm1095sComponent,
        canActivate: [MemberSessionGuard, ACAGuard]
    },
    {
        path: MemberModulePaths.DocumentsBenefitsSummaries,
        component: MemberDocumentBenefitSummariesComponent,
        canActivate: [MemberSessionGuard]
    },
    {
        path: MemberModulePaths.DocumentsBenefits,
        component: MemberDocumentBenefitsComponent,
        canActivate: [MemberSessionGuard]
    },
    {
        path: MemberModulePaths.DocumentsCompany,
        component: MemberDocumentCompanyComponent,
        canActivate: [MemberSessionGuard]
    },
    {
        path: MemberModulePaths.DocumentsCompliance,
        component: MemberDocumentComplianceComponent,
        canActivate: [MemberSessionGuard]
    },
    {
        path: MemberModulePaths.DocumentsContacts,
        component: MemberDocumentContactsComponent,
        canActivate: [MemberSessionGuard]
    },
];

// const MemberRelationComponents = [
//     MemberRelationsFollowUpOpenComponent,
//     MemberRelationsFollowUpCompletedComponent,
//     MemberActivityLogComponent,
// ];

// export const Member6RelationsRoutes: Routes = [
//     {
//         path: MemberModulePaths.Relations,
//         redirectTo: MemberModulePaths.RelationsActivityLog,
//         pathMatch: 'full',
//     },
//     {
//         path: MemberModulePaths.RelationsActivityLog,
//         component: MemberActivityLogComponent,
//         canActivate: [MemberSessionGuard]
//     },
//     {
//         path: MemberModulePaths.RelationsOpenFollowUps,
//         component: MemberRelationsFollowUpOpenComponent,
//         canActivate: [MemberSessionGuard]
//     },
//     {
//         path: MemberModulePaths.RelationsCompletedFollowUps,
//         component: MemberRelationsFollowUpCompletedComponent,
//         canActivate: [MemberSessionGuard]
//     },
// ];

const MemberPayrollComponents = [
    PayrollAddressComponent,
    PayrollAddressFormComponent,
    PayrollDeductionsComponent,
    PayrollFederalTaxTableComponent,
    PayrollFederalTaxFormComponent,
    PayrollStateTaxTableComponent,
    PayrollStateTaxFormComponent,
    PayrollPTOSickHoursComponent,
    PayrollAnnualStatementsComponent,
    PayrollPayStubsComponent,
    PayrollDirectDepositComponent,
    PayrollDirectDepositFormComponent,
    PayrollDashboardComponent,
    PaycheckDetailsComponent,
    CurrentDeductionsComponent
];

export const Member7PayrollRoutes: Routes = [
    {
        path: MemberModulePaths.Payroll,
        pathMatch: 'full',
        redirectTo: MemberModulePaths.PayrollDashboard,
    },
    {
        path: MemberModulePaths.PayrollDashboard,
        component: PayrollDashboardComponent,
        canActivate: [MemberSessionGuard, PayrollGuard]
    },
    {
        path: MemberModulePaths.PayrollAddress,
        component: PayrollAddressComponent,
        canActivate: [MemberSessionGuard, PayrollGuard]
    },
    {
        path: MemberModulePaths.PayrollDeductions,
        component: PayrollDeductionsComponent,
        canActivate: [MemberSessionGuard, PayrollGuard]
    },
    {
        path: MemberModulePaths.PayrollDirectDeposit,
        component: PayrollDirectDepositComponent,
        canActivate: [MemberSessionGuard, PayrollGuard]
    },
    {
        path: MemberModulePaths.PayrollFederalTaxDetails,
        component: PayrollFederalTaxTableComponent,
        canActivate: [MemberSessionGuard, PayrollGuard]
    },
    {
        path: MemberModulePaths.PayrollStateTaxDetails,
        component: PayrollStateTaxTableComponent,
        canActivate: [MemberSessionGuard, PayrollGuard]
    },
    {
        path: MemberModulePaths.PayrollPTOSickHours,
        component: PayrollPTOSickHoursComponent,
        canActivate: [MemberSessionGuard, PayrollGuard]
    },
    {
        path: MemberModulePaths.PayrollAnnualStatements,
        component: PayrollAnnualStatementsComponent,
        canActivate: [MemberSessionGuard, PayrollGuard]
    },
    {
        path: MemberModulePaths.PayrollPayStubs,
        component: PayrollPayStubsComponent,
        canActivate: [MemberSessionGuard, PayrollGuard]
    },
];



export const MemberComponents = [
    MemberDashboardComponents,
    MemberBenefitComponents,
    MemberProfileComponents,
    MemberResourceComponents,
    // MemberRelationComponents,
    MemberAccountingComponents,
    MemberPayrollComponents,
];
